import {Component, EventEmitter, inject, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {
  AuthControllerService,
  Organisation,
  OrganisationControllerService,
  Project,
  ProjectControllerService,
  Role,
  User
} from "../../../api";
import {MatSort} from "@angular/material/sort";
import {ActivatedRoute} from "@angular/router";
import {AddUserDialogComponent} from "./add-user-dialog/add-user-dialog.component";
import {ToolbarService} from "../design/toolbar/toolbar.service";
import {Observable, Subscription} from "rxjs";
import {PermissionService} from "../../../services/permission/permission.service";
import {StateConfigService} from "../../../services/state/state-config.service";
import {
  faCaretDown,
  faChevronDown,
  faChevronRight,
  faCircleInfo,
  faClipboardList,
  faEllipsisVertical,
  faLock,
  faPenToSquare,
  faPlus,
  faTrash,
  faTrashCan,
  faUserPlus,
} from "@fortawesome/pro-solid-svg-icons";
import {MatDialog} from "@angular/material/dialog";
import {MatColumnDef, MatTableDataSource} from "@angular/material/table";
import {CustomRoleDetailComponent} from "../custom-role-detail/custom-role-detail.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {
  CdkCell,
  CdkCellDef,
  CdkColumnDef,
  CdkHeaderCell,
  CdkHeaderCellDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkRow,
  CdkRowDef,
  CdkTable
} from "@angular/cdk/table";
import {NgClass} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {RoleAndPrivilegesPipe} from "../../../pipes/role-and-privileges.pipe";
import {CdkOverlayOrigin} from "@angular/cdk/overlay";
import {
  BicBadgeComponent,
  BicButtonComponent,
  BicDropdownComponent,
  BicDropdownElementComponent,
  BicDropdownTriggerDirective,
  TooltipDirective
} from "@buildinginformationcloud/bic-ui-components";
import {NotificationsService} from "../../../services/notifications/notifications.service";


@Component({
  selector: 'app-users-list[isProject]',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FaIconComponent,
    CdkTable,
    NgClass,
    MatButton,
    MatSort,
    CdkColumnDef,
    CdkHeaderCell,
    CdkHeaderCellDef,
    CdkCell,
    CdkCellDef,
    MatColumnDef,
    RoleAndPrivilegesPipe,
    CdkOverlayOrigin,
    CdkHeaderRow,
    CdkRow,
    CdkRowDef,
    CdkHeaderRowDef,
    BicButtonComponent,
    BicBadgeComponent,
    TooltipDirective,
    BicDropdownTriggerDirective,
    BicDropdownComponent,
    BicDropdownElementComponent,
    CdkOverlayOrigin,
    BicDropdownElementComponent
  ]
})
export class UsersListComponent implements OnInit {
  projectControllerService = inject(ProjectControllerService);
  organisationControllerService = inject(OrganisationControllerService);
  protected permissionService = inject(PermissionService);
  private route = inject(ActivatedRoute);
  private dialog = inject(MatDialog);
  private toolbar = inject(ToolbarService);
  private stateConfigService = inject(StateConfigService);
  private authControllerService = inject(AuthControllerService);
  notificationsService = inject(NotificationsService);


  @Input() fromProjectAccordion: boolean = false;

  @Input() isProject!: boolean;

  @Input() addDisabled: boolean = false;
  @Input() deleteDisabled: boolean = false;
  @Input() permissionsDisabled: boolean = false;

  private eventsSubscription!: Subscription;
  @Input() changeEventTriggered!: Observable<Organisation>;

  @Output() usersChange: EventEmitter<User[]> = new EventEmitter<User[]>();

  user!: User;
  @Input() organisation!: Organisation;
  project!: Project;
  defaultRoles: Role[] = [];

  users: User[] = [];

  displayedColumnsProject: string[] = ['firstName', 'lastName', 'mail', 'authorization', 'actions'];

  displayedColumnsOrganisation: string[] = ['firstName', 'lastName', 'mail', 'authorization', 'actions'];

  dataSource!: MatTableDataSource<User>;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('usersTbSort') usersTbSort = new MatSort();
  @ViewChild('subDropdown') subDropdown!: BicDropdownComponent;


  protected readonly faUserPlus = faUserPlus;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faCaretDown = faCaretDown;
  protected readonly faTrashCan = faTrashCan;
  protected readonly faTrash = faTrash;
  protected readonly faPlus = faPlus;
  protected readonly faLock = faLock;
  protected readonly faEllipsisVertical = faEllipsisVertical;
  protected readonly faPenToSquare = faPenToSquare;

  authToDropdownFrom: User | undefined = undefined;
  clickedInDropdown = false;
  showRoleInfoFor: Role | undefined;
  selectedCustomRole: Role | undefined = undefined;
  /**
   * Ob das Custom-Role-Edit-Overlay offen ist.
   * (Nicht mehr das Role-Objekt selbst als Open-Flag verwenden, damit CDK sauber schließen kann.)
   */
  isCustomRoleOverlayOpen = false;

  /** Origin für das CdkConnectedOverlay (muss ein CdkOverlayOrigin sein, sonst landet CDK bei invalid origin bei (0,0)). */
  triggerOrigin: CdkOverlayOrigin | undefined;

  get canAddUser(): boolean {
    if (this.isProject) {
      return this.stateConfigService.canAddProjectMember();
    }
    return true
  }

  toggleOrigin(origin: CdkOverlayOrigin, role: Role) {
    this.selectedCustomRole = role;
    this.triggerOrigin = origin;
    this.isCustomRoleOverlayOpen = true;
  }

  closeCustomRoleOverlay(): void {
    this.isCustomRoleOverlayOpen = false;
    this.selectedCustomRole = undefined;
    this.triggerOrigin = undefined;
  }

  ngOnInit(): void {

    this.route.data.subscribe(data => {
      this.user = data.user;

      if (!this.user) {
        this.authControllerService.profile().subscribe(user => {
          this.user = user;
        });
      }

      if (!this.project) {
        if(this.stateConfigService.getProject() && this.stateConfigService.getProject() != null){
          this.project = this.stateConfigService.getProject()!;
        }else{
          this.project = data.project;
        }
      }
      if (!this.organisation) {
        this.organisation = data.organisation;
      }

      if (this.isProject) {
        this.projectControllerService.getUsers(this.project.id!).subscribe(users => {
          this.users = users;
          this.dataSource = new MatTableDataSource(this.users);
          this.setupSortingForProject();
        });
        this.projectControllerService.getDefaultProjectRoles().subscribe( roles => {
          this.defaultRoles = roles.sort((a, b) => b.privileges!.length! - a.privileges!.length!);
          this.project.roles = this.defaultRoles;
        });
      } else if (this.organisation && this.organisation.id) {
        this.organisationControllerService.getOrganisationUsers(this.organisation.id!).subscribe(users => {
          this.users = users;
          this.dataSource = new MatTableDataSource(this.users);
          this.setupSortingForOrganisation();
        });
      }
    });

    if (this.changeEventTriggered) {
      this.eventsSubscription = this.changeEventTriggered.subscribe((organisation) => {
        this.organisation = organisation;
        this.reloadUsers();
      });
    }
  }

  ngAfterViewInit() {
    // Only set the sort, data is already loaded in ngOnInit
    if (this.dataSource && this.usersTbSort) {
      this.dataSource.sort = this.usersTbSort;
    }

  }

  addUser(): void {
    let ref = this.dialog.open(AddUserDialogComponent, {
      data: {
        isProject: this.isProject,
        project: this.project,
        organisation: this.organisation
      },
    })

    ref.afterClosed().subscribe(user => {
      this.usersChange.emit(this.users);
      this.reloadUsers();
    });
  }

  removeUser(user: User): void {
    // if (this.project.projectManager?.id == user.id) {
    //   this.snackBar.open("Sie können nicht den Projektverantwortlichen löschen. Ernennen Sie zuerst jemand anderen.", "OK", {duration: 5000});
    // } else {
    this.users = this.users?.filter(p => p.id != user.id)

    if (this.isProject) {
      this.projectControllerService.removeUser(this.stateConfigService.getProjectId()!, user.id!).subscribe(() => {
        this.usersChange.emit(this.users);
        this.notificationsService.showSuccessMessage("Projektmitglied wurde erfolgreich entfernt")
        this.reloadUsers();
      });

    } else {
      this.organisationControllerService.deleteOrganisationUser(this.organisation.id!, user.id!).subscribe(() => {
        this.usersChange.emit(this.users);
        this.notificationsService.showSuccessMessage("Organisationsmitglied wurde erfolgreich entfernt")
        this.reloadUsers();
      });
    }
    // }
  }

  canRemoveUser(user: User): boolean {
    return this.user?.id !== user.id && !this.permissionsDisabled;
  }

  get roles(): Role[] {
    if (this.isProject) {
      return this.project.roles ?? [];
    } else {
      return this.organisation.roles!.sort((a, b) => b.privileges!.length! - a.privileges!.length!) ?? [];
    }
  }

  updateUser(user: User, role: Role): void {
    if (this.isProject) {
      this.projectControllerService.updateUserPermissions(role, this.project.id!, user.id!).subscribe(() => {
        this.notificationsService.showSuccessMessage("Berechtigung wurde erfolgreich geändert")
        this.reloadUsers();
      });

    } else {
      this.organisationControllerService.updateOrganisationUser(role, this.organisation.id!, user.id!).subscribe(() => {
        this.notificationsService.showSuccessMessage("Berechtigung wurde erfolgreich geändert")
        this.reloadUsers();
      });
    }

  }

  private setupSortingForProject(): void {
    if (this.dataSource) {
      this.dataSource.sortingDataAccessor = (row: User, columnName: string): string => {
        if (columnName === 'role') {
          return row.roleInProjects?.[this.project?.id!]?.name ?? '';
        } else if (columnName === 'firstname') {
          return row.firstName || '';
        } else if (columnName === 'lastname') {
          return row.lastName || '';
        }
        return row[columnName as keyof User] as string;
      };
      this.dataSource.sort = this.usersTbSort;
    }

  }

  private setupSortingForOrganisation(): void {
    if (this.dataSource) {
      this.dataSource.sortingDataAccessor = (row: User, columnName: string): string => {
        if (columnName === 'role') {
          return this.getCurrentRole(row)?.name ?? '';
        } else if (columnName === 'firstname') {
          return row.firstName ?? '';
        } else if (columnName === 'lastname') {
          return row.lastName ?? '';
        }
        return row[columnName as keyof User] as string;
      };
      this.dataSource.sort = this.usersTbSort;
    }
  }

  reloadUsers(): void {
    if (this.isProject && this.project) {
      this.projectControllerService.getUsers(this.project.id!).subscribe(users => {
        this.users = users;
        this.dataSource = new MatTableDataSource(this.users);
        this.setupSortingForProject();
      });
    } else if (this.organisation && !this.permissionsDisabled) {
      this.organisationControllerService.getOrganisationUsers(this.organisation.id!).subscribe(users => {
        this.users = users;
        this.dataSource = new MatTableDataSource(this.users);
        this.setupSortingForOrganisation();
      });
    }
  }

  get customRoles(): Role[] {
    if (this.isProject) {
      return this.project.customRoles ?? [];
    } else {
      return this.organisation.customRoles ?? [];
    }
  }

  resendInvitation(user: User): void {
    if (this.isProject) {
      this.projectControllerService.inviteToProject([user.mail ?? ""], this.project.id!).subscribe(() => {
        this.notificationsService.showSuccessMessage("Einladung erfolgreich erneut versendet");
      });
    } else {
      this.organisationControllerService.inviteToOrganisation([user.mail ?? ""], this.organisation.id!).subscribe(() => {
        this.notificationsService.showSuccessMessage("Einladung erfolgreich erneut versendet");
      });
    }
  }

  createCustomRole( user:  User) {
    let customRoleDialog = this.dialog.open(CustomRoleDetailComponent, {
      data: {
        roleName: "",
        isProject: this.isProject,
        organisation: this.organisation
      },
    }).afterClosed().subscribe(result  => {
      if(result){
        this.updateUser(user, result)
      }
      if (this.isProject) {
        this.projectControllerService.getProject(this.project.id!).subscribe(project => {
          this.project = project;
          this.project.roles = this.defaultRoles;
        });
      } else {
        this.organisationControllerService.getOrganisation(this.organisation.id!).subscribe(organisation => {
          this.organisation = organisation;
        });
      }
    })
  }

  //might need to do different things
  editCustomRole(role: Role) {
    let customRoleDialog = this.dialog.open(CustomRoleDetailComponent, {
      panelClass: "rounded-corners-dialog",
      data: {
       role: role,
       isProject: this.isProject,
       organisation: this.organisation
       ,onDelete: (r?: Role) => { if (r) this.deleteCustomRole(r); }
      // pass whether this role is currently assigned so the dialog can disable delete
      ,isAssigned: this.isRoleAssigned(role)
      },
      width: "30%"
    }).afterClosed().subscribe(() => {
      if (this.isProject) {
        this.projectControllerService.getProject(this.project.id!).subscribe(project => {
          this.project = project;
          this.project.roles = this.defaultRoles;
        });
      } else {
        this.organisationControllerService.getOrganisation(this.organisation.id!).subscribe(organisation => {
          this.organisation = organisation;
        });
      }
    })
  }

  deleteCustomRole(role: Role) {
    if (this.isRoleAssigned(role)) {
      this.notificationsService.showErrorMessage(
        'Berechtigung kann nicht gelöscht werden solange sie zugewiesen ist.'
      );
    return;
    }
    if (this.isProject) {
      this.projectControllerService.deleteRole(this.project.id!, role.id!).subscribe(() => {
        this.projectControllerService.getProject(this.project.id!).subscribe(project => {
          this.project = project;
          this.project.roles = this.defaultRoles;
        });
      });
    } else {
      this.organisationControllerService.deleteRole1(this.organisation.id!, role.id!).subscribe(() => {
        this.organisationControllerService.getOrganisation(this.organisation.id!).subscribe(organisation => {
          this.organisation = organisation;
        });
      });
    }

  }

  isRoleAssigned(role: Role): boolean {
  if (!this.dataSource?.data) return false;

  return this.dataSource.data.some(user => {
    if (this.isProject) {
      return user.roleInProjects?.[this.project.id!]?.id === role.id;
    } else {
      return user.roleInOrganisations?.[this.organisation.id!]?.id === role.id;
    }
  });
}

  openedSubMenu() {
    setTimeout(() => {
      this.clickedInDropdown = false;
    }, 100)
  }

  onClickSomewhereToCloseMenues() {
    if (!this.clickedInDropdown) {
      this.authToDropdownFrom = undefined;
      this.selectedCustomRole = undefined
    }
  }

  permissionToAddUser(element: User): void {
    if(!this.permissionsDisabled && element.id != this.user.id){
      this.authToDropdownFrom = element
    }else{
      this.authToDropdownFrom = undefined;
    }

  }

  /**
   * Liefert die Rolle des Mitglieds im aktuellen Projekt bzw. in der aktuellen Organisation.
   * Enthält die Rolle in der Nutzerliste nur eine Referenz (ID ohne Namen), wird sie über die
   * Rollen des Projekts bzw. der Organisation aufgelöst, damit der Name sofort angezeigt wird.
   */
  getCurrentRole(element: User): Role | undefined {
    const role = this.isProject
      ? (this.project?.id ? element.roleInProjects?.[this.project.id] : undefined)
      : (this.organisation?.id ? element.roleInOrganisations?.[this.organisation.id] : undefined);
    if (!role || role.name) {
      return role;
    }
    const knownRoles: Role[] = this.isProject
      ? [...(this.project?.roles ?? []), ...(this.project?.customRoles ?? [])]
      : [...(this.organisation?.roles ?? []), ...(this.organisation?.customRoles ?? [])];
    return knownRoles.find(r => r.id === role.id) ?? role;
  }

  getCurrentRoleTooltip(element: User): string {
    const role = this.getCurrentRole(element);

    return role ? this.getRoleTooltip(role) : '';
  }

  getRoleTooltip(role: Role): string {
    switch (role.name) {
      case 'PROJECT_ADMIN':
        return 'Kaufrechte, sowie Verwaltung von Projektdaten, Mitgliedern und Berechtigungen';
      case 'ORGANISATION_ADMIN':
        return 'Kaufrechte, sowie Verwaltung von Projektdaten, Mitgliedern und Berechtigungen';
      case 'PROJECT_EDITOR':
        return 'Dateien hochladen, bearbeiten oder löschen sowie Ausführung von Prüfungen';
      case 'ORGANISATION_EDITOR':
        return 'Dateien hochladen, bearbeiten oder löschen sowie Ausführung von Prüfungen';
      case 'PROJECT_VIEWER':
        return 'Lesezugriff auf Projektdaten und Dateien sowie Prüfberichte und Modelle';
      case 'ORGANISATION_VIEWER':
        return 'Lesezugriff auf Projektdaten und Dateien sowie Prüfberichte und Modelle';
      default:
        return '';
    }
  }

  protected readonly faClipboardList = faClipboardList;

  protected readonly faChevronDown = faChevronDown;
  protected readonly faCircleInfo = faCircleInfo;

  isCreator(element: User): boolean {
    if (this.isProject && this.project?.creator) {
      return this.project.creator.id === element.id;
    } else if (!this.isProject && this.organisation?.creator) {
      return this.organisation.creator.id === element.id;
    }
    return false;
  }
}
